import styled from 'styled-components';

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const DoughnutWrapper = styled.div`
  width: 146px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;
  position: relative;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    width: 30%;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 146px;
  }
`;

export const CompletionWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PercentageWrapper = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
